import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import injectSheet from 'react-jss';

import {
  black1,
  black2,
  bold,
  evisortRed,
} from '~/assets/shared-styles/general';
import { PAGE_SIZE, PAGE_START } from '~/common/constants/page';
import AdminConsolePageNavHeader from '~/components/Admin/AdminConsolePageNavHeader/AdminConsolePageNavHeader';
import {
  addDepartment,
  addDepartmentMembers,
  deleteDepartment,
  getClientDepartment,
  listDepartmentMembers,
  removeDepartmentMembers,
  renameDepartment,
} from '~/components/Admin/DepartmentsPage/DepartmentsPage.data';
import ActionsMenu from '~/components/Shared/ActionsMenu/ActionsMenu';
import EcCard from '~/components/Shared/EcCard/EcCard';
import EcDepartmentsTable from '~/components/Shared/EcDepartmentsTable/EcDepartmentsTable';
import EcMembersTable from '~/components/Shared/EcMembersTable/EcMembersTable';
import EcModal from '~/components/Shared/EcModal/EcModal';
import EcPaginate from '~/components/Shared/EcPaginate/EcPaginate';
import { showToast } from '~/components/Shared/EcToast/showToast';
import LoadingSpinner from '~/components/Shared/Icons/LoadingSpinner';
import PlusIcon from '~/components/Shared/Icons/PlusIcon';
import { Button } from '~/eds/src/components/Button/Button';
import { Modal } from '~/eds/src/components/Modal/Modal';
import { DepartmentNameModal } from '~/features/departments/DepartmentNameModal';
import { FlagType } from '~/flags/flags';
import { withFlags } from '~/flags/withFlags';
import { withRouting } from '~/routing/withRouting';
import {
  MODAL_DELETE,
  MODAL_DELETE_DEPARTMENT,
  MODAL_DEPARTMENT_MEMBERS,
  MODAL_NAME,
} from '~/types/modal.types';
import { ERROR, SUCCESS } from '~/types/toast.types';

const tableStyles = { padding: '0 16px' };

class Page extends Component {
  constructor(props) {
    super(props);

    this.handlePageClick = this.handlePageClick.bind(this);
    this.navigateBack = this.navigateBack.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.onDepartmentCreate = this.onDepartmentCreate.bind(this);
    this.onDepartmentEdit = this.onDepartmentEdit.bind(this);
    this.onDepartmentRename = this.onDepartmentRename.bind(this);
    this.onDepartmentDelete = this.onDepartmentDelete.bind(this);
    this.onMembersDelete = this.onMembersDelete.bind(this);
    this.handleRemoveUsers = this.handleRemoveUsers.bind(this);

    this.state = {
      page: PAGE_START,
      departmentLoaded: false,
      membersLoaded: false,
      members: [],
      membersTotalCount: 0,
      membersToRemove: [],
      selectedDepartment: null,
      selectedItem: null,
    };
  }

  UNSAFE_componentWillMount() {
    this.getClientDepartment();
  }

  componentDidUpdate(prevProps) {
    const {
      params: { departmentId },
    } = this.props;
    if (
      departmentId &&
      prevProps.params.departmentId !== this.props.params.departmentId
    ) {
      this.getClientDepartment(departmentId);
    }
  }

  getClientDepartment(id) {
    const { page } = this.state;
    const {
      params: { departmentId },
    } = this.props;

    const deptId = id || departmentId;

    getClientDepartment(deptId)
      .then((res) => {
        this.setState({
          department: res,
          departmentLoaded: true,
          errorLoadingDepartment: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.status === 403) {
          this.setState({ errorLoadingDepartment: false, noAccess: true });
        } else {
          this.setState({ errorLoadingDepartment: true });
        }
      })
      .finally(() => {
        this.setState({ departmentLoaded: true });
      });

    listDepartmentMembers(deptId, page, PAGE_SIZE)
      .then((res) => {
        this.setState({
          members: res.results,
          membersTotalCount: res.count,
          errorLoadingMembers: false,
          membersLoaded: true,
        });
      })
      .catch((err) => {
        if (err.response && err.response.status === 403) {
          this.setState({ errorLoadingMembers: false, noAccess: true });
        } else {
          this.setState({ errorLoadingMembers: true });
        }
      })
      .finally(() => {
        this.setState({ membersLoaded: true });
      });
  }

  navigateBack() {
    this.props.navigate(-1);
  }

  handlePageClick(clickedPage) {
    const selectedPage = clickedPage.selected + 1;
    this.setState({ page: selectedPage, membersLoaded: false }, () => {
      this.getClientDepartment();
    });
  }

  handleShowModal(modal, departmentName, forSubdepartment = false) {
    this.setState({
      modal,
      selectedDepartment: departmentName,
      forSubdepartment,
    });
  }

  handleHideModal() {
    this.setState({
      modal: null,
      selectedItem: null,
    });
  }

  handleShowToast(type, text) {
    showToast(type, text);
  }

  renderDepartmentNameModal() {
    const { intl, flags } = this.props;
    const {
      params: { departmentId },
    } = this.props;
    const { selectedDepartment, forSubdepartment } = this.state;

    const enableModalConsolidation = flags[FlagType.ModalConsolidation];

    let title;
    let labelText;
    let itemsCurrentName;
    let itemsParentDepartmentId;
    let confirmButtonIcon;
    let confirmButtonText;
    let handleNameChange;

    if (selectedDepartment && !forSubdepartment) {
      labelText = intl.formatMessage({
        id: 'DepartmentDetail.departmentNameLabel',
        defaultMessage: 'DEPARTMENT NAME',
        description: 'Department name form field label',
      });
      title = intl.formatMessage({
        id: 'DepartmentDetail.renameDepartmentTitle',
        defaultMessage: 'Rename Department',
        description: 'Rename department modal title',
      });
      confirmButtonText = intl.formatMessage({
        id: 'DepartmentDetail.saveButton',
        defaultMessage: 'Save',
        description: 'Save button text',
      });
      itemsCurrentName = selectedDepartment.department_name;
      itemsParentDepartmentId = null;
      handleNameChange = this.onDepartmentRename;
    } else if (!!forSubdepartment) {
      labelText = intl.formatMessage({
        id: 'DepartmentDetail.departmentNameLabel',
        defaultMessage: 'DEPARTMENT NAME',
        description: 'Department name form field label',
      });
      title = intl.formatMessage({
        id: 'DepartmentDetail.addSubdepartmentTitle',
        defaultMessage: 'Add Subdepartment',
        description: 'Add subdepartment modal title',
      });
      itemsParentDepartmentId = departmentId;
      confirmButtonIcon = <PlusIcon size="20" color="#000" />;
      confirmButtonText = intl.formatMessage({
        id: 'DepartmentDetail.createSubdepartmentButton',
        defaultMessage: 'Create Subdepartment',
        description: 'Create subdepartment button text',
      });
      handleNameChange = this.onDepartmentCreate;
    } else {
      labelText = intl.formatMessage({
        id: 'DepartmentDetail.departmentNameLabel',
        defaultMessage: 'DEPARTMENT NAME',
        description: 'Department name form field label',
      });
      title = intl.formatMessage({
        id: 'DepartmentDetail.addDepartmentTitle',
        defaultMessage: 'Add Department',
        description: 'Add department modal title',
      });
      itemsCurrentName = '';
      itemsParentDepartmentId = null;
      confirmButtonIcon = <PlusIcon size="20" color="#000" />;
      confirmButtonText = intl.formatMessage({
        id: 'DepartmentDetail.createDepartmentButton',
        defaultMessage: 'Create Department',
        description: 'Create department button text',
      });
      handleNameChange = this.onDepartmentCreate;
    }

    return enableModalConsolidation ? (
      <DepartmentNameModal
        title={title}
        labelText={labelText}
        confirmButtonText={confirmButtonText}
        onConfirm={handleNameChange}
        onCancel={this.handleHideModal}
        itemsCurrentName={itemsCurrentName}
        itemsParentFolderId={itemsParentDepartmentId}
      />
    ) : (
      <EcModal
        modalType={MODAL_NAME}
        width="560px"
        title={title}
        labelText={labelText}
        itemsCurrentName={itemsCurrentName}
        itemsParentFolderId={itemsParentDepartmentId}
        confirmButtonIcon={confirmButtonIcon}
        confirmButtonText={confirmButtonText}
        handleNameChange={handleNameChange}
        hideModal={this.handleHideModal}
      />
    );
  }

  renderDeleteDepartmentModalText() {
    const { intl } = this.props;
    const {
      selectedDepartment: { department_name },
    } = this.state;

    return (
      <div>
        {intl.formatMessage(
          {
            id: 'DepartmentDetail.deleteDepartmentConfirmation',
            defaultMessage:
              "Are you sure you want to delete {departmentName} department? You won't be able to undo this action.",
            description:
              'Delete department confirmation message. Example: departmentName = "Engineering"',
          },
          {
            departmentName: department_name,
          },
        )}
      </div>
    );
  }

  renderDeleteDepartmentModal() {
    const { intl } = this.props;
    const { selectedDepartmentBeforeDelete } = this.state;

    return (
      <Modal
        title={intl.formatMessage({
          id: 'DepartmentDetail.deleteDepartmentTitle',
          defaultMessage: 'Delete Department?',
          description: 'Delete department modal title',
        })}
        isVisible={true}
        onHide={this.handleHideModal}
        primaryAction={{
          onClick: this.onDepartmentDelete,
          text: selectedDepartmentBeforeDelete
            ? intl.formatMessage({
                id: 'DepartmentDetail.deleteAndAssignButton',
                defaultMessage: 'Delete and Assign',
                description: 'Delete and assign button text',
              })
            : intl.formatMessage({
                id: 'DepartmentDetail.deleteButton',
                defaultMessage: 'Delete',
                description: 'Delete button text',
              }),
          variant: 'danger',
        }}
        children={this.renderDeleteDepartmentModalText()}
      />
    );
  }

  renderDeleteMembersModalText() {
    const { intl } = this.props;
    const {
      membersToRemove,
      department: { department_name },
    } = this.state;

    return (
      <div>
        {intl.formatMessage(
          {
            id: 'DepartmentDetail.removeMembersConfirmation',
            defaultMessage:
              "Are you sure you want to remove {count} {count, plural, one {user} other {users}} from the {departmentName} department? You won't be able to undo this action.",
            description:
              'Remove members confirmation message with pluralization. Example: departmentName = "Engineering"',
          },
          {
            count: membersToRemove.length,
            departmentName: department_name,
          },
        )}
      </div>
    );
  }

  renderDeleteMembersModal() {
    const { intl } = this.props;
    return (
      <Modal
        title={intl.formatMessage({
          id: 'DepartmentDetail.removeFromDepartmentTitle',
          defaultMessage: 'Remove from Department?',
          description: 'Remove from department modal title',
        })}
        isVisible={true}
        onHide={this.handleHideModal}
        primaryAction={{
          onClick: this.onMembersDelete,
          text: intl.formatMessage({
            id: 'DepartmentDetail.removeButton',
            defaultMessage: 'Remove',
            description: 'Remove button text',
          }),
          variant: 'danger',
        }}
        children={this.renderDeleteMembersModalText()}
      />
    );
  }

  onMembersDelete() {
    const { intl } = this.props;
    const {
      params: { clientId, departmentId },
    } = this.props;
    const {
      membersToRemove,
      department: { department_name },
    } = this.state;

    removeDepartmentMembers(
      clientId,
      departmentId,
      department_name,
      membersToRemove,
    )
      .then((data) => {
        this.handleShowToast(
          SUCCESS,
          intl.formatMessage(
            {
              id: 'DepartmentDetail.usersRemovedSuccess',
              defaultMessage: 'Users have been removed from {departmentName}.',
              description:
                'Success message when users are removed from department. Example: departmentName = "Engineering"',
            },
            {
              departmentName: data.department_name,
            },
          ),
        );
        this.setState({
          page: 1,
          membersLoaded: false,
          departmentLoaded: false,
        });
        this.getClientDepartment();
        this.handleHideModal();
      })
      .catch(() => {
        this.handleShowToast(
          ERROR,
          intl.formatMessage({
            id: 'DepartmentDetail.removeUsersError',
            defaultMessage:
              'An error occurred while removing users from the department.',
            description:
              'Error message when removing users from department fails',
          }),
        );
      });
  }

  onDepartmentCreate(name) {
    const { intl } = this.props;
    const {
      params: { clientId, departmentId },
    } = this.props;

    const { forSubdepartment, selectedDepartment } = this.state;

    const members = [];
    const parent =
      forSubdepartment && selectedDepartment
        ? selectedDepartment.department_id
        : departmentId
          ? departmentId
          : null;

    addDepartment(name, members, parent, clientId)
      .then((data) => {
        this.handleShowToast(
          SUCCESS,
          intl.formatMessage(
            {
              id: 'DepartmentDetail.departmentCreatedSuccess',
              defaultMessage: 'Department {departmentName} is created.',
              description:
                'Success message when department is created. Example: departmentName = "Engineering"',
            },
            {
              departmentName: data.department_name,
            },
          ),
        );
        this.getClientDepartment();
      })
      .catch((err) => {
        if (
          err &&
          err.response.status === 400 &&
          err.response &&
          err.response.data
        ) {
          this.handleShowToast(ERROR, err.response.data[0]);
        } else {
          this.handleShowToast(
            ERROR,
            intl.formatMessage({
              id: 'DepartmentDetail.departmentCreateError',
              defaultMessage:
                'An error occurred while creating the new department.',
              description: 'Error message when department creation fails',
            }),
          );
        }
      });
  }

  onDepartmentEdit(members) {
    const { intl } = this.props;
    const {
      params: { clientId, departmentId },
    } = this.props;
    const {
      department: { department_name },
    } = this.state;

    addDepartmentMembers(clientId, departmentId, department_name, members)
      .then((data) => {
        this.handleShowToast(
          SUCCESS,
          intl.formatMessage(
            {
              id: 'DepartmentDetail.usersAddedSuccess',
              defaultMessage: 'Users have been added to {departmentName}.',
              description:
                'Success message when users are added to department. Example: departmentName = "Engineering"',
            },
            {
              departmentName: data.department_name,
            },
          ),
        );
        this.setState({
          page: 1,
          membersLoaded: false,
          departmentLoaded: false,
        });
        this.getClientDepartment();
        this.handleHideModal();
      })
      .catch(() => {
        this.handleShowToast(
          ERROR,
          intl.formatMessage({
            id: 'DepartmentDetail.addUsersError',
            defaultMessage:
              'An error occurred while adding users to the department.',
            description: 'Error message when adding users to department fails',
          }),
        );
      });
  }

  onDepartmentRename(name) {
    const { intl } = this.props;
    const { selectedDepartment } = this.state;
    const {
      params: { clientId },
    } = this.props;
    const departmentId = selectedDepartment.department_id;

    renameDepartment(clientId, departmentId, name)
      .then((data) => {
        this.handleShowToast(
          SUCCESS,
          intl.formatMessage(
            {
              id: 'DepartmentDetail.departmentRenamedSuccess',
              defaultMessage: 'Department is renamed to {departmentName}.',
              description:
                'Success message when department is renamed. Example: departmentName = "Engineering"',
            },
            {
              departmentName: data.department_name,
            },
          ),
        );
        this.getClientDepartment();
        this.handleHideModal();
      })
      .catch((err) => {
        if (
          err &&
          err.response.status === 400 &&
          err.response &&
          err.response.data
        ) {
          this.handleShowToast(ERROR, err.response.data[0]);
        } else {
          this.handleShowToast(
            ERROR,
            intl.formatMessage({
              id: 'DepartmentDetail.departmentRenameError',
              defaultMessage:
                'An error occurred while renaming the new department.',
              description: 'Error message when department rename fails',
            }),
          );
        }
      });
  }

  onDepartmentDelete() {
    const { intl } = this.props;
    const { selectedDepartment } = this.state;
    const departmentId = selectedDepartment.department_id;

    deleteDepartment(departmentId)
      .then(() => {
        this.handleShowToast(
          SUCCESS,
          intl.formatMessage({
            id: 'DepartmentDetail.departmentDeletedSuccess',
            defaultMessage: 'Department has been deleted.',
            description: 'Success message when department is deleted',
          }),
        );
        this.navigateBack();
      })
      .catch(() => {
        this.handleShowToast(
          ERROR,
          intl.formatMessage({
            id: 'DepartmentDetail.departmentDeleteError',
            defaultMessage: 'An error occurred while deleting the department.',
            description: 'Error message when department deletion fails',
          }),
        );
      });
  }

  renderDepartmentsTableData() {
    const { intl } = this.props;
    const {
      params: { clientId },
    } = this.props;
    const { department } = this.state;

    return (
      <EcCard contentStyles={tableStyles}>
        <EcDepartmentsTable
          header={intl.formatMessage({
            id: 'DepartmentDetail.subdepartmentsHeader',
            defaultMessage: 'Subdepartments',
            description: 'Subdepartments table header',
          })}
          clientId={clientId}
          listItems={department.children}
          handleShowModal={this.handleShowModal}
        />
      </EcCard>
    );
  }

  handleRemoveUsers(membersToRemove) {
    this.setState({ membersToRemove });
  }

  renderMembersTableData() {
    const { intl, classes } = this.props;
    const {
      params: { clientId },
    } = this.props;
    const { members } = this.state;
    return (
      <div className={classes.membersTablContainer}>
        <EcCard contentStyles={tableStyles}>
          <EcMembersTable
            header={intl.formatMessage({
              id: 'DepartmentDetail.usersHeader',
              defaultMessage: 'Users',
              description: 'Users table header',
            })}
            clientId={clientId}
            listItems={members}
            handleShowModal={this.handleShowModal}
            handleAddUnassignedUsers={this.handleAddUnassignedUsers}
            handleRemoveUsers={this.handleRemoveUsers}
          />
        </EcCard>
      </div>
    );
  }

  renderPagination() {
    const { classes } = this.props;
    const { membersTotalCount, page } = this.state;
    return (
      membersTotalCount > PAGE_SIZE && (
        <div className={classes.paginationWrapper}>
          <EcPaginate
            onPageChange={this.handlePageClick}
            pageCount={Math.ceil(membersTotalCount / PAGE_SIZE)}
            forcePage={page - 1}
          />
        </div>
      )
    );
  }

  renderAddMembersModal() {
    const { intl } = this.props;
    const {
      params: { clientId, departmentId },
    } = this.props;

    return (
      <EcModal
        modalType={MODAL_DEPARTMENT_MEMBERS}
        width="560px"
        title={intl.formatMessage({
          id: 'DepartmentDetail.addUsersToDepartmentTitle',
          defaultMessage: 'Add Users to Department',
          description: 'Add users to department modal title',
        })}
        confirmButtonIcon={<PlusIcon size="20" color={black1} />}
        confirmButtonText={intl.formatMessage({
          id: 'DepartmentDetail.addUsersButton',
          defaultMessage: 'Add Users',
          description: 'Add users button text',
        })}
        handleActionClick={this.onDepartmentEdit}
        hideModal={this.handleHideModal}
        clientId={clientId}
        departmentId={departmentId}
      />
    );
  }

  render() {
    const { intl, classes } = this.props;
    const {
      modal,
      noAccess,
      departmentLoaded,
      membersLoaded,
      errorLoadingDepartment,
      errorLoadingMembers,
      department,
    } = this.state;

    if (!departmentLoaded || !membersLoaded) {
      return (
        <div className={classes.loadingContainer}>
          <LoadingSpinner size="medium" />
        </div>
      );
    } else if (noAccess) {
      return (
        <div>
          <p>
            {intl.formatMessage({
              id: 'DepartmentDetail.noAccessMessage',
              defaultMessage: 'You do not have permission to access this page.',
              description: 'No access permission message',
            })}
          </p>
          <p>
            {intl.formatMessage({
              id: 'DepartmentDetail.contactAdminMessage',
              defaultMessage:
                'To request permission, contact your organization administrator.',
              description: 'Contact admin message for permissions',
            })}
          </p>
        </div>
      );
    } else if (errorLoadingDepartment || errorLoadingMembers) {
      return (
        <div className={classes.errorLoadingMessage}>
          {intl.formatMessage({
            id: 'DepartmentDetail.errorLoadingMessage',
            defaultMessage: 'An error occurred while loading the department.',
            description: 'Error loading department message',
          })}
        </div>
      );
    }
    return (
      <div>
        <div className={classes.pageNavHeaderContainer}>
          <AdminConsolePageNavHeader
            title={department.department_name}
            subTitle={intl.formatMessage({
              id: 'DepartmentDetail.departmentsSubtitle',
              defaultMessage: 'Departments',
              description: 'Departments subtitle in navigation header',
            })}
            navigateBack={this.navigateBack}
          />
          <span className={classes.headerButton}>
            <Button
              text={intl.formatMessage({
                id: 'DepartmentDetail.renameButton',
                defaultMessage: 'Rename',
                description: 'Rename button text',
              })}
              onClick={() => this.handleShowModal(MODAL_NAME, department)}
            />
            <ActionsMenu
              id={`${department.department_name}_actions_menu`}
              items={[
                {
                  content: intl.formatMessage({
                    id: 'DepartmentDetail.deleteAction',
                    defaultMessage: 'Delete',
                    description: 'Delete action menu item text',
                  }),
                  onClick: () =>
                    this.handleShowModal(
                      MODAL_DELETE_DEPARTMENT,
                      department,
                      false,
                    ),
                },
              ]}
              align="end"
              title={intl.formatMessage({
                id: 'DepartmentDetail.editDepartmentMenuTitle',
                defaultMessage: 'edit department menu',
                description: 'Edit department menu title for accessibility',
              })}
            />
          </span>
        </div>
        {this.renderDepartmentsTableData()}
        {this.renderMembersTableData()}
        {this.renderPagination()}
        {modal === MODAL_NAME ? this.renderDepartmentNameModal() : null}
        {modal === MODAL_DELETE ? this.renderDeleteMembersModal() : null}
        {modal === MODAL_DELETE_DEPARTMENT
          ? this.renderDeleteDepartmentModal()
          : null}
        {modal === MODAL_DEPARTMENT_MEMBERS
          ? this.renderAddMembersModal()
          : null}
      </div>
    );
  }
}

Page.propTypes = {
  classes: PropTypes.object,
  intl: PropTypes.object.isRequired,
};

const styles = {
  subheadWrapper: {
    display: 'flex',
  },
  subheader: {
    marginBottom: '24px',
    color: black2,
    fontSize: '19px',
    fontWeight: bold,
    lineHeight: '33px',
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
  },
  errorLoadingMessage: {
    color: evisortRed,
  },
  membersTablContainer: {
    marginTop: '24px',
  },
  pageNavHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  headerButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& button': {
      marginRight: '20px',
    },
  },
};

export default injectSheet(styles)(withFlags(withRouting(injectIntl(Page))));
